/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  default-case,
  eqeqeq,
  import/no-extraneous-dependencies,
  max-len,
  no-console,
  no-return-assign,
  react/no-unescaped-entities
*/
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages, FormattedMessage } from 'react-intl';
import {
  actions, Errors, Control, Form,
} from 'react-redux-form';
import HfReactHelper from 'common/utils/hf-react-helper';
import { stringify } from 'qs';
import superagent from 'superagent';
import { connect } from 'react-redux';
import helloSvg from 'common/images/hello.svg';
import { trackHeapCustomEvent } from 'common/utils/heap';
import ThirdPartyLogin from './components/third-party/third-party-login';
import { EmailField, InviteText, SignupButton } from './components/auth-form-components';
import { loadArkoseCdnScript } from './arkose';
import PrivacyTOSLinks from './components/privacy-policy-and-tos';
import './sign-up-form.scss';
import {
  EU_COUNTRIES,
  REST_OF_THE_WORLD,
  MARKETING_EMAIL_AUTO_OPT_IN_COUNTRIES,
  EUROPEAN_COUNTRIES_LIST,
} from '../pricing/constants';

const FORM_NAME = 'signUp';
const SKIP_LIST = new RegExp(/.+[+].*@(hellosign.com|hellodocument.com)$/);
let formValues = null;

const messages = defineMessages({
  emailAddress: {
    id: '',
    description: 'remember me text on login page',
    defaultMessage: 'EMAIL ADDRESS',
  },
});

export class SignUpForm extends React.Component {
  static propTypes = {
    siteCode: PropTypes.string.isRequired,
    csrfToken: PropTypes.string,

    // URL used to submit the form via POST
    submitUrl: PropTypes.string.isRequired,

    // URLs displayed to the user as links for Terms/Privacy Policy
    tosUrl: PropTypes.string.isRequired,
    privacyPolicyUrl: PropTypes.string.isRequired,

    // Provided from Redux state by connect
    pending: PropTypes.bool.isRequired,

    // Needed by the GoogleSignInButton component
    isOptedIn: PropTypes.bool.isRequired,

    // Implicitly Accept ToS
    implicitlyOptedIn: PropTypes.string,

    // Redux dispatcher object, provided from Redux by connect
    dispatch: PropTypes.func.isRequired,

    // Needed by the GoogleSignInButton component
    googleSignInClientId: PropTypes.string.isRequired,

    // Used if this is a team invite signup (note: if provided, emailAddress is also required)
    isInvite: PropTypes.bool,
    teamInviteGuid: PropTypes.string,
    teamInviteSenderEmail: PropTypes.string,

    // Email address to pre-fill (required if teamInviteSenderEmail is provided)
    emailAddress: PropTypes.string,
    signupSource: PropTypes.string,

    // We need a logInUrl when we show the sign in link in the footer of this form
    logInUrl: PropTypes.string,

    countryCode: PropTypes.string,

    intl: PropTypes.object,

    // Used to only display the HelloSign sign up option for the Microsoft Office Integration
    isOfficeAddIn: PropTypes.bool,
    arkoseSignUpPublicKey: PropTypes.string.isRequired,
    // Decides whether Arkose should be displayed
    arkoseSignUpEnabled: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      arkoseSignUpEnforcement: null,
      arkoseToken: null,
    };

    this.handleGeneralError = this.handleGeneralError.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleResponse = this.handleResponse.bind(this);
    this.preSubmit = this.preSubmit.bind(this);
    this.getIsOptedIn = this.getIsOptedIn.bind(this);

  }

  componentDidMount() {
    // Map site codes to alt/title text versions of logo
    const textVersions = {
      S: 'HelloSign',
      F: 'HelloFax',
      W: 'HelloWorks',
    };
    if (this.props.arkoseSignUpEnabled) {
      this.loadArkose();
    }
    hellofaxJS.trackGAPageViewEvent('accountSignUp', null, null, null, textVersions[this.props.siteCode]);
  }

  /**
   * Handles any generic/fallback errors we want to handle
   */
  handleGeneralError() {
    this.props.dispatch(actions.setSubmitFailed(FORM_NAME));
  }

  handleResponse(err, response) {
    // Error here means some kind of network error (4xx or 5xx)
    if (err) {
      trackHeapCustomEvent('sign_up_create_account_error', { err: 'Some kind of network error' });
      return this.handleGeneralError(err);
    }

    try {
      const resp = response.body;

      // Create notification if backend provided one
      if (resp.notification) {
        hellofaxJS.createNotification({
          text: resp.notification.message,
          class_name: resp.notification.type,
        });
      }

      // Handle success and failure
      if (resp.success === true) {
        this.props.dispatch(actions.setSubmitted(FORM_NAME));

        // Redirect to redirect_url
        if (resp.redirect_url) {
          window.location = resp.redirect_url;
        }
      } else {
        this.props.dispatch(actions.setSubmitFailed(FORM_NAME));

        if (resp.error.code === 'Z') {
          // Clean up the token we had in the state
          this.setState({ arkoseToken: null });
          // Is we received an arkose response, rollout was enabled
          // in the middle of the session so let's load the test
          if (!this.state.arkoseSignUpEnforcement) {
            this.loadArkose();
          } else {
            // Rerun the test
            this.state.arkoseSignUpEnforcement.run();
          }
        }

        const hasErrorMsg = !!(resp.error && resp.error.message);
        if (hasErrorMsg && !resp.notification_message) {
          trackHeapCustomEvent('sign_up_create_account_error', { err: resp.error.message });
          // Display error message
          this.props.dispatch(
            actions.setErrors(FORM_NAME, {
              server: resp.error.message,
            }),
          );
        }
      }

      if (response.error) {
        trackHeapCustomEvent('sign_up_create_account_error', { err: resp.error.message });
        this.props.dispatch(
          actions.setErrors(FORM_NAME, {
            server: resp.error.message,
          }),
        );
      }
    } catch (e) {
      return this.handleGeneralError(err);
    }
  }

  preSubmit(values) {
    trackHeapCustomEvent('sign_up_create_account', {});
    formValues = values;
    this.handleSubmit(values);
  }

  handleSubmit(values) {
    // Set those in the state if we need to use them after a test
    this.setState({ formValues: values });
    formValues = values;

    if (this.props.arkoseSignUpEnabled && !SKIP_LIST.test(formValues.email) && !this.state.arkoseToken) {
      // Save the form values in the state so we can use them after verification
      return this.state.arkoseSignUpEnforcement.run();
    }
    // Prepare the POST
    const isOptedInMarketingEmails = EUROPEAN_COUNTRIES_LIST.includes(this.props.countryCode)
      ? !values.marketingOptIn
      : values.marketingOptIn;

    const data = stringify({
      signup: {
        email_address: values.email,
        // toggling values for european countries as they are auto opted in, user checking the checkbox is to opt out
        is_opted_in_marketing_emails: isOptedInMarketingEmails,
        redirect_url: values.redirectUrl,
        pending_tsm_group_guid: values.pendingTsmGroupGuid,
        team_invite_guid: this.props.teamInviteGuid,
        _csrf_token: values.csrfToken,
        country_code: this.props.countryCode,
      },
      force_delay_analytics_js: true,
      async: 1,
      arkose_token: this.state.arkoseToken,
    });

    // POST to the server
    return superagent
      .post(this.props.submitUrl)
      .type('form')
      .send(data)
      .on('request', () => {
        this.props.dispatch(actions.setPending(FORM_NAME));
      })
      .end(this.handleResponse);
  }

  handleArkoseEnforcementCompleted(response) {
    this.setState({ arkoseToken: response.token });
    // Go back and submit the form
    this.handleSubmit(this.state.formValues);
  }

  loadArkose() {
    loadArkoseCdnScript(this.props.arkoseSignUpPublicKey, (enforcement) => {
      enforcement.setConfig({
        data: {},
        onCompleted: (response) => {
          this.handleArkoseEnforcementCompleted(response);
        },
        onHide: () => {},
        onReady: () => {},
        onReset: () => {},
        onShow: () => {},
        onShown: () => {},
        onSuppress: () => {},
      });
      // Add the enforcement to the state so we can use it later
      this.setState({ arkoseSignUpEnforcement: enforcement });
    });
  }

  getIsOptedIn() {
    return this.props.isOptedIn;
  }

  getHeader() {
    let header = <div>
      <h2><FormattedMessage id='' defaultMessage='Create your account' description='sign up page' /></h2>
    </div>;
    if (this.props.signupSource === 'dropbox') {
      header = <div className="row m-sign-up-form--greeting">
        <img src={helloSvg} />
      </div>;
    }
    return header;
  }

  getSignInLink() {
    if (!HfReactHelper.HfSites.isHelloSign(this.props.siteCode) && !this.props.signupSource) {
      return;
    }

    const { logInUrl } = this.props;
    if (logInUrl === undefined) {
      return;
    }

    const a = (msg) => (<a href={logInUrl}>{msg}</a>);

    return <div className="m-sign-up-form--sign-in-link">
      <div className="m-sign-up-form--h-divider"></div>
      <p><FormattedMessage id='' defaultMessage='Already have an account? <a>Sign in ›</a>' description='sign up page' values={{ a }} /></p>
    </div>;
  }

  render() {
    const {
      siteCode,
      tosUrl,
      privacyPolicyUrl,
      pending,
      emailAddress,
      teamInviteGuid,
      teamInviteSenderEmail,
      googleSignInClientId,
      isOfficeAddIn,
    } = this.props;
    const isInvite = !!teamInviteGuid;
    const siteName = siteCode == 'F' ? 'HelloFax' : 'HelloSign';
    const formType = 'signup'; // used to associate backend CSRF form origination

    const header = this.getHeader();

    const signInLink = !isOfficeAddIn && this.getSignInLink();

    // Map site codes to site names
    const siteAbbreviations = {
      S: 'hs',
      F: 'hf',
      W: 'hw',
    };

    const officeAddInDivider = isOfficeAddIn && <hr className="l-margin-v-30" />;

    const rejectInviteUrl = isInvite
      && HfReactHelper.urlHelper(
        `account/confirmTeamInvite?execute=1&does_accept=0&guid=${teamInviteGuid}`,
      );

    const a3 = (msg) => (<a href={rejectInviteUrl}>{msg}</a>);

    const rejectInviteLink = isInvite
      && <div className="m-sign-up-form--sign-in-link">
        <hr />
        <p>
          <FormattedMessage id='' defaultMessage='You may also <a3>decline this invitation.</a3>'
            description='sign up page'
            values={{ a3 }} />
        </p>
      </div>;

    const MarketingOptIn = this.props.implicitlyOptedIn !== MARKETING_EMAIL_AUTO_OPT_IN_COUNTRIES
      && (
        <div className='m-sign-up-form--marketing-opt-in'>
          <div className="m-sign-up-form--checkbox-opt-in">
            <Control.checkbox model="signUp.marketingOptIn" data-qa-ref="opt_in_marketing_emails_checkbox" />{' '}
          </div>
          <label>
            {this.props.implicitlyOptedIn === REST_OF_THE_WORLD
            && (
              <FormattedMessage
                id=''
                defaultMessage='I would like to receive marketing email updates from {siteName}'
                description='checkbox, asks user if user agrees to receive marketing/updates emails'
                values={{ siteName }} />
            )}
            {this.props.implicitlyOptedIn === EU_COUNTRIES
            && (
              <FormattedMessage
                id=''
                defaultMessage='I do not want to receive marketing email updates from {siteName}'
                description='checkbox, asks user if user wants to remove marketing/updates emails'
                values={{ siteName }} />
            )}
          </label>
        </div>
      );

    return (
      <div className="m-sign-up-form">
        {header}
        { !isInvite
          && !isOfficeAddIn
          && <ThirdPartyLogin
            googleSignInClientId={googleSignInClientId}
            getIsOptedIn={this.getIsOptedIn}
            formType={formType}
            csrfToken={this.props.csrfToken}
            isSignup={true}
            siteCodeString={siteAbbreviations[this.props.siteCode]} />
        }
        {officeAddInDivider}
        <Form model={FORM_NAME} onSubmit={this.preSubmit}>
          {!isInvite && <EmailField emailAddressMessage={messages.emailAddress} emailAddress={emailAddress} formatMessage={this.props.intl.formatMessage} /> }
          {this.props.countryCode !== '' ? MarketingOptIn : null }
          {isInvite && <InviteText teamInviteSenderEmail={teamInviteSenderEmail} domain={siteName} emailAddress={emailAddress} /> }
          {<SignupButton isInvite={isInvite} pending={pending} siteCodeString={siteAbbreviations[this.props.siteCode]} />}
          <div className="l-margin-v-20" >
            <Errors
              model={FORM_NAME}
              show={true}
              className="c-red l-margin-v-20" />
          </div>
          <p className="l-margin-t-10 l-margin-b-0 m-sign-up-form--tos">
            <PrivacyTOSLinks siteName={siteName} tosUrl={tosUrl} privacyPolicyUrl={privacyPolicyUrl} />
          </p>
          {rejectInviteLink}
          {signInLink}
        </Form>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { $form } = state.forms.signUp;

  return {
    emailAddress: state.signUp.email,
    pending: $form.pending,
    isOptedIn: state.signUp.marketingOptIn,
    csrfToken: state.signUp.csrfToken,
    countryCode: state.signUp.countryCode,
  };
}

export default connect(mapStateToProps)(injectIntl(SignUpForm));
